var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M464,112.808v-36.12L387.312,0H160v112H40c-22.056,0-40,17.944-40,40v256c0,22.056,17.944,40,40,40h96v32h-32v16h288v-16 h-32v-32h96c22.056,0,40-17.944,40-40V152C496,132.688,482.232,116.528,464,112.808z M384,19.312L444.688,80H384V19.312z M176,16 h192v80h80v256H176V16z M344,480H152v-32h192V480z M480,408c0,13.232-10.768,24-24,24H40c-13.232,0-24-10.768-24-24v-8h464V408z  M480,384H16V152c0-13.232,10.768-24,24-24h120v240h304V129.472c9.288,3.312,16,12.112,16,22.528V384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,200c0-30.872-25.128-56-56-56s-56,25.128-56,56s25.128,56,56,56S144,230.872,144,200z M96,184c0,4.416-3.584,8-8,8 s-8-3.584-8-8s3.584-8,8-8S96,179.584,96,184z M88,240c-5.56,0-10.856-1.152-15.672-3.216C73.816,229.504,80.28,224,88,224 c7.72,0,14.184,5.504,15.672,12.784C98.856,238.848,93.56,240,88,240z M88,208c-13.056,0-24.264,7.872-29.232,19.104 C52.144,219.96,48,210.48,48,200c0-20.4,15.408-37.096,35.168-39.512C72.24,162.728,64,172.424,64,184 C64,197.232,74.768,208,88,208s24-10.768,24-24c0-11.576-8.24-21.272-19.168-23.512C112.592,162.904,128,179.6,128,200 c0,10.48-4.144,19.96-10.768,27.104C112.264,215.872,101.056,208,88,208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,312c0,30.872,25.128,56,56,56s56-25.128,56-56s-25.128-56-56-56S32,281.128,32,312z M88,352 c-5.56,0-10.856-1.152-15.672-3.216C73.816,341.504,80.28,336,88,336c7.72,0,14.184,5.504,15.672,12.784 C98.856,350.848,93.56,352,88,352z M96,296c0,4.416-3.584,8-8,8s-8-3.584-8-8c0-4.416,3.584-8,8-8S96,291.584,96,296z  M83.168,272.488C72.24,274.728,64,284.424,64,296c0,13.232,10.768,24,24,24s24-10.768,24-24c0-11.576-8.24-21.272-19.168-23.512 C112.592,274.904,128,291.6,128,312c0,10.48-4.144,19.96-10.768,27.104C112.264,327.872,101.056,320,88,320 c-13.056,0-24.264,7.872-29.232,19.104C52.144,331.96,48,322.48,48,312C48,291.6,63.408,274.904,83.168,272.488z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,63.312V48h-80v80h80V82.968l28.648-20.464l-9.296-13.016L288,63.312z M272,74.744l-15.136,10.808l-11.208-11.208 l-11.312,11.312l20.792,20.792L272,94.4V112h-48V64h48V74.744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,159.312V144h-80v80h80v-45.032l28.648-20.464l-9.296-13.016L288,159.312z M272,170.744l-15.136,10.808 l-11.208-11.208l-11.312,11.312l20.792,20.792L272,190.4V208h-48v-48h48V170.744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,255.312V240h-80v80h80v-45.032l28.648-20.464l-9.296-13.008L288,255.312z M272,266.744l-15.136,10.808 l-11.208-11.208l-11.312,11.312l20.792,20.792L272,286.4V304h-48v-48h48V266.744z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 112,
    width: 96,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 208,
    width: 96,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 304,
    width: 96,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 272,
    width: 96,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 176,
    width: 96,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 80,
    width: 32,
    height: 16
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubrics);
export default __webpack_public_path__ + "static/media/Rubrics.47470a88990d75602559705c2417b1b1.svg";
export { ForwardRef as ReactComponent };